import {AppMainComponent} from '@oc/shell-core'
import routes from './Components/routes'
import {BrowserRouter} from 'react-router'
import {RouteSwitch} from '@oc/shell-core'
import {AuthenticationContextProvider} from '@oc/shell-core'
import {observer} from 'mobx-react-lite'
import {RootLayout} from './Components/RootLayout'

function App() {
    return (
        <BrowserRouter>
            <AuthenticationContextProvider>
                <AppMainComponent>
                    <RootLayout>
                        <RouteSwitch routes={routes} />
                    </RootLayout>
                </AppMainComponent>
            </AuthenticationContextProvider>
        </BrowserRouter>
    )
}

export default observer(App)
